import axios from 'axios'

const api = axios.create({
  // baseURL: 'https:/indicator.api.v2.formulariodevisto.com'
  baseURL: process.env.REACT_APP_API_URL
})

export default api
